import React from "react";
import { View, Modal, SafeAreaView, Platform } from "react-native";
import { BallIndicator } from "react-native-indicators";

import ImageIcon from "component/typography/ImageIcon";
import Shadow from "component/section/Shadow";

import { colors, sizes } from "asset/constant";
import { logo } from "asset/logo";
import { css } from "style";
import { mq } from "utils";
import Img from "component/img";
import ImgIcon from "component/typography/ImageIcon";

export default function FullScreenLoading() {
  return (
    <Modal transparent animationType="fade">
      <SafeAreaView
        style={{
          ...css.centralElContainer,
          backgroundColor: colors.modal_bg.dark_glass,
        }}
      >
        <Shadow>
          <View
            style={{
              width: mq(150),
              height: mq(150),
              ...css.centralElements,
              backgroundColor: colors.white,
              borderRadius: sizes.radius.lg,
            }}
          >
            {Platform.OS !== "web" ? (
              <View
                style={{
                  flex: 1,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Img
                  source={logo.entries_screens}
                  style={{ width: "90%", aspectRatio: 3.161 }}
                  resizeMode="contain"
                />
              </View>
            ) : (
              <ImageIcon
                icon={logo.entries_screens}
                width={mq(100)}
                height={mq(80)}
              />
            )}
            <BallIndicator
              size={mq(30)}
              color={colors.theme}
              style={{ top: mq(-10) }}
            />
          </View>
        </Shadow>
      </SafeAreaView>
    </Modal>
  );
}
